import request from "@/utils/http"
import store from "@/store"
import { getCachedObj } from "@/utils/cache"

export function setCurCompany(companyId) {
  store.dispatch("app/cleanProjectPermission")
  return request.post(`/users/setCurCompany/${companyId}`).commonDeal()
}

export function createCompany(company) {
  return request.post("/users/company/create", company).commonDeal()
}

export function updateDingConfig(company) {
  return request.post("/users/company/updateDingConfig", company).commonDeal()
}

export function getCompany(companyId) {
  return request.get("/users/company/get/" + companyId)
}

export function getCurCompany() {
  return request.get("/users/company/cur/get").commonDeal()
}

export function updateCompany(company) {
  return request.post("/users/company/update", company).commonDeal()
}

export function getCurUserCompanies() {
  return request.get("/users/companies")
}

// ///////////////////////////////////////////// 企业日历

export function getCalendar() {
  return request.get("/project/getCalendar").commonDeal()
}

export function updateCalendar(workCalendar) {
  return request.post("/project/updateCalendar", workCalendar).commonDeal()
}

// ///////////////////////////////////////////// 企业角色

export function getCompanyRolesWithNum() {
  return request.get("/users/getCompanyRolesWithNum").commonDeal()
}

/**
 * 有id为更新,无id为新建
 * @param companyRole
 * @returns {*}
 */
export function saveCompanyRole(companyRole) {
  return request.post("/users/saveCompanyRole", companyRole).commonDeal()
}

export function deleteCompanyRole(companyRoleId) {
  return request.post("/users/deleteCompanyRole", null, { params: { companyRoleId } }).commonDeal()
}

export function addUserToCompany({ telephone, name, superior, position, departmentIds, roleIds }) {
  return request
    .post("/users/addUserToCompany", {
      telephone,
      name,
      superior,
      position,
      departmentIds,
      roleIds
    })
    .commonDeal()
}

export function updateCompanyUser({ userId, superior, email, position, departmentIds, roleIds }) {
  return request
    .post("/users/updateCompanyUser", { userId, superior, email, position, departmentIds, roleIds })
    .commonDeal()
}

// export function removeCompanyUser(userId) {
//   return request.post("/users/removeCompanyUser", null, { params: { userId } }).commonDeal()
// }

// ///////////////////////////////////////////// 企业成员

/**
 *
 * @param companyId 非必填
 * @param noCache 是否使用缓存
 * @param withLastReqTime 是否返回最后一次请求时间
 * @returns {*}
 */
export function getCompanyUsers({
  companyId = store.getters.userInfo?.companyId,
  noCache = false,
  withLastReqTime = false
} = {}) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve([])
  }
  let key = `getCompanyUsers_${companyId}`
  let reqFunc = () =>
    request.get("/users/getCompanyUsers", { params: { companyId, withLastReqTime } }).commonDeal()
  return noCache ? reqFunc() : getCachedObj({ key, reqFunc })
}

/**
 *
 * @param companyId 非必填
 * @param noCache 是否使用缓存
 * @returns {*}
 */
export function getDepartmentTree({
  companyId = store.getters.userInfo?.companyId,
  noCache = false
} = {}) {
  if (store.getters.isTemplateMode || !companyId) {
    return Promise.resolve({})
  }
  let key = `getDepartmentTree_${companyId}`
  let reqFunc = () =>
    request.get("/users/getDepartmentTree", { params: { companyId } }).commonDeal()
  return noCache ? reqFunc() : getCachedObj({ key, reqFunc })
}

/**
 * 最近一次钉钉用户同步成功时间
 * @returns {*}
 */
export function getLastSyncDingUserTime() {
  return request.get("/users/getLastSyncDingUserTime").commonDeal()
}

export function syncDingUser() {
  return request.post("/users/syncDingUser").commonDeal()
}

export function joinCompany(companyCode) {
  return request.post(`/users/joinCompany`, null, { params: { companyCode } }).commonDeal()
}
